import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { TranslocoService } from '@jsverse/transloco';
import { AuthService } from '@shared/services/auth.service';
import { NotificationService } from '@shared/services/notificacion/notification.service';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const notification = inject(NotificationService);
  const transloco = inject(TranslocoService);

  if (!authService.isLoggedIn()) {
    if (authService.isSessionExpired() && authService.hasStoredUser()) {
      authService.logout('expirada');
    } else {
      notification.danger(transloco.translate('auth.session.requiredTitle'), transloco.translate('auth.session.requiredMsg'));
      router.navigate(['/auth/login'], { queryParams: { returnUrl: state.url } });
    }
    return false;
  }

  return true;
};